export default {
  "content": "<path d=\"M17.259 9.15l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3 2.24 2.614 5.242-6.115 1.518 1.301z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.928 4.928c3.906-3.905 10.238-3.905 14.143 0 3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.143 0-3.905-3.905-3.905-10.237 0-14.143zm12.729 1.415A8.001 8.001 0 106.343 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};